module.exports = __webpack_public_path__ + "static/media/background.3d02a8bd.svg";